module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"NEW APPLICATIONS","notFound":"Nothing found"},"et":{"title":"NEW APPLICATIONS","notFound":"Nothing found"},"ru":{"title":"NEW APPLICATIONS","notFound":"Nothing found"}}')
  delete Component.options._Ctor
}
